import { useState } from 'react';

const MetricCard = ({ title, value, subtitle, icon, trend, color = 'blue', tooltip }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const colorClasses = {
    blue: 'bg-primary-100 text-primary-600',
    primary: 'bg-primary-100 text-primary-600',
    green: 'bg-green-100 text-green-600',
    yellow: 'bg-yellow-100 text-yellow-600',
    red: 'bg-red-100 text-red-600',
    purple: 'bg-purple-100 text-purple-600',
    gray: 'bg-gray-100 text-gray-600',
    orange: 'bg-orange-100 text-orange-600',
  };

  const borderColors = {
    blue: 'border-l-primary-500',
    primary: 'border-l-primary-500',
    green: 'border-l-green-500',
    yellow: 'border-l-yellow-500',
    red: 'border-l-red-500',
    purple: 'border-l-purple-500',
    gray: 'border-l-gray-400',
    orange: 'border-l-orange-500',
  };

  return (
    <div className={`bg-white rounded-xl shadow-sm border-l-4 ${borderColors[color]} p-5 hover:shadow-md transition-all relative`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <p className="text-sm font-medium text-gray-600">{title}</p>
            {tooltip && (
              <div className="relative">
                <button
                  className="text-gray-400 hover:text-primary-600 focus:outline-none transition-colors"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => setShowTooltip(!showTooltip)}
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                </button>
                {showTooltip && (
                  <div className="absolute left-0 top-6 z-50 w-72 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg">
                    <div className="font-semibold mb-1">{tooltip.title}</div>
                    <div className="text-gray-300">{tooltip.description}</div>
                    {tooltip.formula && (
                      <div className="mt-2 pt-2 border-t border-gray-700">
                        <span className="font-semibold">Fórmula: </span>
                        <span className="text-gray-300">{tooltip.formula}</span>
                      </div>
                    )}
                    {tooltip.example && (
                      <div className="mt-2 pt-2 border-t border-gray-700">
                        <span className="font-semibold">Exemplo: </span>
                        <span className="text-gray-300">{tooltip.example}</span>
                      </div>
                    )}
                    <div className="absolute -top-1 left-4 w-2 h-2 bg-gray-900 transform rotate-45"></div>
                  </div>
                )}
              </div>
            )}
          </div>
          <p className="text-3xl font-bold text-gray-800">{value}</p>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
          {trend && (
            <p className={`text-xs mt-2 font-medium ${trend.positive ? 'text-green-600' : 'text-red-600'}`}>
              {trend.value} {trend.label}
            </p>
          )}
        </div>
        {icon && (
          <div className={`p-3 rounded-xl ${colorClasses[color]}`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;
